import { AppNavigate } from "./AppNavigate";

export interface NavigateSlaveProps {
  to?: string;
}

// Slave fallback redirect: only the sticky queries (slave,
// bridgeWebsocketEndpoint, settings…) survive, applied by AppNavigate.
export const NavigateSlave = ({ to }: NavigateSlaveProps) => {
  return <AppNavigate to={to ?? '/'} replace />;
};
